import Handlebars from "utilities/vendor/handlebars/4.7.7/js/handlebars";
import hbs from "utilities/vendor/handlebars/4.7.7/js/handlebars";







const helpers = {





  abbr(a) {
    const abbr = a;
    if (!abbr) {
      return '';
    }

    const { value } = abbr;
    delete abbr.value;
    let attr = '';

    const attrTemplate = (n, v) => `${n}="${v}"`;
    const abbrTemplate = (attributes, text) => `<abbr ${attributes}>${text}</abbr>`;

    Object.keys(abbr).forEach((key) => {
      attr += attrTemplate(key, abbr[key]);
    });

    return abbrTemplate(attr, value);
  },






  ada(options) {
    return new Handlebars.SafeString(
      `<span class="ada-hidden" data-version="2.0.0">${options.fn(this)}</span>`,
    );
  },






  debug(logName) {
    const label = (typeof logName !== 'undefined') ? `Sparta Debug: ${logName}` : '';

    const output = `<script>
        console.group('${label}');
        console.group(${JSON.stringify(this)});
        console.groupEnd();
        console.groupEnd();
      </script>`;

    return new Handlebars.SafeString(output);
  },






  debug_print(logName) {
    const label = (typeof logName !== 'undefined') ? `Sparta Debug: ${logName}` : '';

    const debugStyles = {};
    debugStyles.wrapper = 'position:relative; border:5px solid #333; padding:18px 10px 10px; margin: 5px 0;';
    debugStyles.header = 'position: absolute; top: 0; left: 0; width: 100%; height: 18px; font-size: 11px; background-color: #333; color: #fff; padding: 0; margin: 0;';

    const output = `<div class="spa-debug" data-debug="${label}" style="${debugStyles.wrapper}">
        <pre><h3 style="${debugStyles.header}">${label}</h3>
        ${JSON.stringify(this, 0, 2)}
        </pre>
      </div>`;

    return new Handlebars.SafeString(output);
  },





  elementAttributes(attributes) {
    if (!attributes) return;
    const output = [];
    const attrs = Object.entries(attributes);
    attrs.forEach((el) => {
      const elementAttribute = el[0];
      const elementAttributeData = el[1];

      if (typeof (elementAttributeData) === 'object') {

        if (Array.isArray(elementAttributeData)) {


          const tempArray = [];
          elementAttributeData.forEach((el) => {
            let index = el.trim();
            if (index.substring(index.length - 1) !== ';') {
              index += ';';
            }
            tempArray.push(index);
          });
          output.push(`${elementAttribute.toLowerCase()}="${tempArray.join(' ')}"`);
        } else {

          const prefix = elementAttribute.toLowerCase();
          Object.keys(elementAttributeData).forEach((el) => (output.push(`${prefix}-${el}="${attributes[elementAttribute][el]}"`)));
        }

      } else if (typeof (elementAttributeData) === 'boolean') {
        if (elementAttributeData === true) {
          output.push(`${elementAttribute}`);
        }

      } else {
        output.push(`${elementAttribute}="${elementAttributeData}"`);
      }
    });

    return new Handlebars.SafeString(` ${output.join(' ')}`);
  },






  link(linkData) {

    if (!linkData) {
      return '';
    }
    const link = linkData;

    link.CLASS = link.CLASS || '';

    let windowOptions;
    const layerClasses = {
      layer: 'spa-ui-layer-link spa-fn',
      popup: 'spa-fn spa-boa-window',
    };
    let showAdaLayer = false;


    if (link.button) {
      link.CLASS += ' spa-btn';

      const { button } = link;

      const buttonsConfig = {
        sizes: {
          default: 'spa-btn--small',
          small: 'spa-btn--small',
          medium: 'spa-btn--medium',
          large: 'spa-btn--large',
          engagement: 'spa-btn--engagement',
        },
        skins: {
          default: 'spa-btn--primary',
          primary: 'spa-btn--primary',
          secondary: 'spa-btn--secondary',
          reverse: 'spa-btn--reverse',
          disabled: 'spa-btn--disabled',
        },
        expand: {
          small: 'spa-btn--expand-on-small',
          medium: 'spa-btn--expand-on-medium',
        },
      };



      if ((button.width || button.height) && button.size) {
        console.log('You may not set the button size with width and/or height. Choose one.');
      }



      if (button.skin) {
        link.CLASS += ` ${buttonsConfig.skins[button.skin]}`;
      }


      if (button.expand) {
        const buttonExpandKeys = Object.keys(buttonsConfig.expand);


        if (buttonExpandKeys.indexOf(button.expand) === -1) {
          console.log(`Button expand property may only be set as ${buttonExpandKeys.join(', ')}.`);
        }


        link.CLASS += ` ${buttonsConfig.expand[button.expand]}`;
      }


      if (button.block) {
        link.CLASS += ' spa-btn--block';
      }


      if (button.size) {
        const buttonSizeKeys = Object.keys(buttonsConfig.sizes);


        if (!buttonsConfig.sizes[button.size]) {
          console.log(`Button size property may only be set as ${buttonSizeKeys.join(', ')}.`);
        }


        link.CLASS += ` ${buttonsConfig.sizes[button.size]}`;
      } else {
        link.CLASS += ` ${buttonsConfig.sizes.default}`;
      }
    }


    if (link.guillemet) {
      const { guillemet } = link;

      link.CLASS += ' spa-guillemet';

      if (guillemet === 'left') {
        link.CLASS += ' spa-guillemet--left';
      }
    }


    if (link.actionType) {

      if (link.actionType.options) {
        windowOptions = link.actionType.options;
        link.OPTIONS = JSON.stringify(link.actionType.options);
      }


      if (link.actionType.type === 'layer') {
        showAdaLayer = true;
        link.REL = link.actionType.options.rel;
        link.CLASS += ` ${layerClasses[link.actionType.type]}`;

        if (link.actionType.options && link.actionType.options.interstitalType) {

          link.CLASS += ' spa-ui-layer-interstitial';
        } else if (link.actionType.options && link.actionType.options.layerType) {

          link.CLASS += ' spa-ui-layer-tooltip-link';
        }
      }


      if (link.actionType.type === 'popup') {


        if ((windowOptions.width || windowOptions.height) && windowOptions.size) {
          console.log(
            util.format('You may not set the popup size with width and/or height. Choose one.'),
          );
        }


        link.CLASS += ` ${layerClasses[link.actionType.type]}`;
      }
    }


    if (link.CLASS.length) {
      link.CLASS = link.CLASS.replace(/^\s+|\s+$/g, '');
    }


    const escapeString = (string) => {  
      var escape = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        "'": '&#x27;',
        '`': '&#x60;',
        '=': '&#x3D;',
      };
      var badChars = /[&<>'`=]/g,
          possible = /[&<>'`=]/;
      if (typeof string !== 'string') {

          if (string && string.toHTML) {
          return string.toHTML();
          } else if (string == null) {
          return '';
          } else if (!string) {
          return string + '';
          }




          string = '' + string;
      }

      if (!possible.test(string)) {
        return string;
      }
      function escapeChar(chr) {
        return escape[chr];
      }
      return string.replace(badChars, escapeChar);

       };


    const linkUrl = link.URL || 'javascript:void(0);';
    const output = `<a
        ${(link.vueOptionsStr) ? `${link.vueOptionsStr}` : ''}
        id="${link.ID || ''}"
        href="${linkUrl}"
        ${link.DATA_URL ? `data-href="${link.DATA_URL}"` : ''}
        ${link.CLASS ? `class="${link.CLASS}"` : ''}
        ${link.REL ? `rel="${link.REL}"` : ''}
        ${link.OPTIONS ? `data-options='${escapeString(link.OPTIONS)}'` : ''}
        ${link.TARGET ? `target="${link.TARGET}"` : ''}
        ${link.ROLE ? `role="${link.ROLE}"` : ''}
        ${link.bactmln ? `data-bactmln="${link.bactmln}"` : ''}
        ${link.tabIndex ? `tabindex="${link.tabIndex}"` : ''}
        ${link.onclick ? `onclick="${link.onclick}"` : ''}
      >
        ${link.content}
        ${showAdaLayer ? '<span class="spa-ada-text ada-hidden">&nbsp;layer</span>' : ''}
      </a>`;

    return new Handlebars.SafeString(output);
  },







  layerContent(data, options) {
    const escapedOptions = Handlebars.Utils.escapeExpression(JSON.stringify(data.options));


    const tagType = data.options.type === 'modal'
      ? 'h1'
      : 'h3';


    let showTitle = '';
    if (data.title) {
      showTitle = `<${tagType} id="${data.id}_title" class="spa-ui-layer-title" data-font="cnx-bold">${data.title}</${tagType}>`;
    }


    let content = '';
    if (options && options.isBlockHelperOptions) {
      const blockHelperTemplate = Handlebars.compile(`${options.helperBlockContent}`);
      content = blockHelperTemplate(data);
    }
    if (options && Object.prototype.hasOwnProperty.call(options, 'fn')) {
      content = options.fn(this);
    }


    let footerContent = '';
    if (data.footer) {
      for (const index in data.footer) {
        footerContent += data.footer[index];
      }
      footerContent = `<div id="${data.id}_footer" class="spa-footer">${footerContent}</div>`;
    }


    const output = `<div id="${data.id}" class="hide" data-options="${escapedOptions}">
        ${showTitle}
        <div class="content">${content}</div>
        ${footerContent}
    </div>`;

    return new Handlebars.SafeString(output);
  },






  spriteRules(o) {
    let output = '';
    const writeRule = (exp) => {
      let css = '';

      switch (exp.experience) {
        case 'hires':
          css += 'html.mq-hires ';
          break;
        case 'fallback':
          css += 'html.lt-ie9 ';
          break;
        default: break;
      }
      if (exp.context !== 'default') {
        css += `.${exp.context} `;
      }

      css += `.sprite .spr {\n\tbackground-image: url("${exp.image}");\n`;
      if (exp.width && exp.height) {
        css += `\tbackground-size: ${exp.width} ${exp.height};\n`;
      }
      css += '}\n\n';

      return css;
    };

    const oMod = o;
    Object.keys(o).forEach((context) => {
      Object.keys(o[context]).forEach((experience) => {
        oMod[context][experience].context = context;
        oMod[context][experience].experience = experience;
        output += writeRule(oMod[context][experience]);
      });
    });

    return output;
  },





  writeBackgroundImage(...args) {
    const breakpoints = [];
    let output = '';

    const writeBreakpoint = (breakpointArgs, breakpoint) => {
      const selector = breakpointArgs[0];
      let lowres = [];
      let hires = [];
      let position = [];
      let size = [];
      let mq = '';
      let css = '';

      const addAttribute = (item, marker, list) => {
        if (typeof item === 'undefined' || typeof item[marker] === 'undefined') {
          return list;
        }

        switch (typeof item[marker]) {
          case 'string':
            list.push(item[marker]);
            break;

          case 'object': {
            const tmp = [];
            Object.keys(item[marker]).forEach((key) => {
              if (key === 'width' || key === 'height') {
                addAttribute(item[marker], key, tmp);
              }
            });
            list.push(tmp.join(' '));
            break;
          }

          default: break;
        }

        return list;
      };

      const writeRule = (attribute, ruleSelector, values, filter) => {
        let value = values.join(', ');
        if (attribute === 'background-image') {
          value = `url("${values.join('"), url("')}")`;
        }

        return (values.length > 0)
          ? `${filter ? `${filter} ` : ''}${ruleSelector} { ${attribute}: ${value}; }\n`
          : '';
      };

      for (let i = 1; i < breakpointArgs.length - 1; i += 1) {
        try {
          const b = breakpointArgs[i][breakpoint];

          lowres = addAttribute(b, 'lowres', lowres);
          hires = addAttribute(b, 'hires', hires);
          if (lowres.length > hires.length) {
            hires.push(lowres[lowres.length - 1]);
          }

          size = addAttribute(b, 'size', size);
          position = addAttribute(b, 'position', position);
        } catch (err) {

        }
      }

      mq = (breakpoint === 'default') ? '' : `html.mq-${breakpoint}`;

      css += writeRule('background-image', selector, lowres, mq);
      css += writeRule(
        'background-image',
        selector,
        hires,
        `html.mq-hires${mq.replace('html', '')}`,
      );
      css += writeRule('background-size', selector, size, mq);
      css += writeRule('background-position', selector, position, mq);

      return css;
    };



    for (let i = 1; i < args.length - 1; i += 1) {
      Object.keys(args[i]).forEach((breakpoint) => {
        if (breakpoints.indexOf(breakpoint) === -1) {
          breakpoints.push(breakpoint);
        }
      });
    }


    for (let b = 0; b < breakpoints.length; b += 1) {
      output += writeBreakpoint(args, breakpoints[b]);
    }

    return new Handlebars.SafeString(output);
  },








  writeDynamicId(type, base, output) {
    let id = '';
    const content = [];
    const badCharacters = ['&amp;', '[^A-Za-z0-9]'];
    const cleanCharacters = (str) => {
      const replaceThese = new RegExp(badCharacters.join('|'), 'g');
      let strMod = str.replace(replaceThese, '-');

      strMod = strMod.split('-').filter((n) => (n !== '')).join('-');
      strMod = strMod.replace(/^-|-$/g, '');
      return strMod;
    };
    const writeAttribute = (idValue) => ` id="${idValue}"`;

    const typeMod = (this.id && base) ? 'id' : type;
    switch (typeMod) {
      case 'id':
        content.push(this.id);
        break;

      case 'simple':
        if (this.text) {
          content.push(this.text);
        }
        break;

      case 'faq':
        if (this.question) {
          content.push(this.question);
        }
        break;

      case 'guide':
        if (this.heading) {
          content.push(this.heading);
        }
        if (this.subHeading) {
          content.push(this.subHeading);
        }
        break;

      case 'map':
        if (this.meta.type) {
          content.push(this.meta.type);
        }
        if (this.location.street1) {
          content.push(this.location.street1);
        }
        if (this.location.street2) {
          content.push(this.location.street2);
        }
        if (this.location.postal) {
          content.push(this.location.postal);
        }
        break;

      default: break;
    }

    if (content.length > 0) {
      id = content.join('-').toLowerCase();
      id = cleanCharacters(id);
      if (base && base.length > 0 && id.indexOf(base) !== 0) {
        id = `${base}-${id}`;
      }
      if (output !== 'bare') {
        id = writeAttribute(id);
      }
    }

    return id;
  },







  spriteAdd(value, change) {
    if (typeof value !== 'undefined') {
      return `${parseInt(value.replace('px', ''), 10) + change}px`;
    }
    return value;
  },







  spriteSubtract(value, change) {
    if (typeof value !== 'undefined') {
      return `${parseInt(value.replace('px', ''), 10) - change}px`;
    }
    return value;
  },






  incrementValue(value) {
    if (typeof value !== 'undefined') {
      return parseInt(value, 10) + 1;
    }
    return 0;
  },






  footnote(target) {
    const output = `<span class="spa-footnote-ref" data-footnote-ref="${target}"></span>`;
    return new Handlebars.SafeString(output);
  },
};




class helpersSparta {





  static register(Handlebars) {
    Object.keys(helpers).forEach((key) => {
      Handlebars.registerHelper(key, helpers[key]);
    });
  }
}

module.exports = helpersSparta;
module.exports.helpers = helpers;
